import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { useOutsideClick } from '@scramble/hooks';
import IconChevron from '@scramble/design-system/icons/chevron-down.svg';
import { AccordionItemProps } from './types';
import s from './index.module.scss';

export const AccordionItem = ({ title, text, children, closeOnOutsideClick = true}: AccordionItemProps) => {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);

  useOutsideClick(ref, () => setOpen(false), closeOnOutsideClick && open);

  return (
    <div className={s.wrapper} ref={ref} tabIndex={0}>
      <div className={s.inner} onClick={() => setOpen(!open)}>
        <div className={s.title}>{title}</div>
        <div className={classnames(s.icon, open && 'open')}>
          <img src={IconChevron} alt="icon" width={16} height={16} />
        </div>
      </div>
      <div className={classnames(s.outer, open && 'open')}>
        <div className={s.content}>
          {text && <span className={s.text}>{text}</span>}
          {children}
        </div>
      </div>
    </div>
  );
};